import {
  StorefrontProduct,
  StorefrontProductOption
} from '@/modules/product/types/product'
import { createLogger } from '@/common/logger'

const getPriceLogger = createLogger({ prefix: 'getPrice' })

export const getFeaturedImage = (product: StorefrontProduct) => {
  if (!product || !product.images.length) {
    return ''
  }
  // noinspection JSUnresolvedVariable
  if (product.featuredImageId) {
    const featuredImage = product.images.find(toCheck => toCheck.id === product.featuredImageId)
    return !featuredImage ? '' : featuredImage.url
  }
  return product.images[0].url
}

export type GetPriceProps = {
  /**
   * If provided, will obtain price from object
   */
  option?: StorefrontProductOption
  /**
   * If provided, will return pricing for quantity value
   */
  quantity?: number
  /**
   * If option is not provided, an arbitrary value to attempt to coerce to price
   */
  price?: string|number
}

export type GetPriceResponse = {
  /**
   * Price in pennies
   */
  price: number
  /**
   * Price in dollars 
   */
  inDollars: number
  /**
   * Price in dollars, formatted with currency symbol
   */
  formatted: string
}

//TODO #currency this will need to be updated for support of other currencies

/**
 * Obtains an object with price-related props for the arps given
 */
export const getPrice = (props: GetPriceProps): GetPriceResponse => {
  const {price, quantity, option} = props
  
  let processed = 0
  if (option) {
    processed = option.price
  } else if (price) {
    processed = parseFloat(""+price)
    if (isNaN(processed)) {
      getPriceLogger.warn(`Invalid price value`, price)
      processed = 0
    }
  }
  
  processed = !quantity ? processed : processed * quantity
  
  const inDollars = processed / 100
  const formatted = `$${inDollars.toFixed(2)}`

  return {
    price: processed,
    inDollars,
    formatted
  }  
}

export const findOption = ({product, id}) => {
  const option = (product?.options || [])
    .filter(opt => opt.id === id)[0]
  
  return option
}